import React, { useState, useEffect, useRef } from 'react'
import Navbar from '../Header-pages/Navbar'
import Footer from '../Header-pages/Footer'
import Topnavbar from '../Header-pages/Topnavbar'
import CareersApplicatioms from './CareersApplicatioms'
import '../Css/CareersDetails.css'
import { API_URL } from '../utils/Function';
import { useNavigate } from 'react-router-dom'

// Import FontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { 
  faClock, 
  faBriefcase, 
  faTimes 
} from '@fortawesome/free-solid-svg-icons';

export default function Careers() {
  const [careers, setCareers] = useState([]);
  const [filteredCareers, setFilteredCareers] = useState([]);
  const [selectedCareer, setSelectedCareer] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedTitles, setSelectedTitles] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [sortBy, setSortBy] = useState('newest');
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showOverlay, setShowOverlay] = useState(false);
  const [showApplicationModal, setShowApplicationModal] = useState(false);
  const [selectedCareerForApplication, setSelectedCareerForApplication] = useState(null);
  const navigate = useNavigate();
  
  // Apply Now button states
  const [isApplyHovered, setIsApplyHovered] = useState(false);
  const [applyParticles, setApplyParticles] = useState([]);
  const applyButtonRef = useRef(null);

  // Hero Section Styles
  const heroStyles = {
    hero: {
      position: 'relative',
      height: '300px',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
    },
    heroOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.4) 100%)',
    },
    breadcrumbs: {
      marginBottom: '20px',
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
    },
    breadcrumbLink: {
      color: '#fff',
      textDecoration: 'none',
      transition: 'color 0.3s',
    },
    breadcrumbSeparator: {
      margin: '0 10px',
      color: '#fff',
    },
    heroTitle: {
      fontSize: '3rem',
      fontWeight: '700',
      color: 'white',
      marginBottom: '10px',
    },
    heroSubtitle: {
      fontSize: '1.3rem',
      color: 'rgba(255, 255, 255, 0.9)',
    },
    container: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 20px',
    }
  };

  // Fetch careers data
  useEffect(() => {
    fetchCareers();
  }, []);

  const fetchCareers = async () => {
    try {
      const response = await fetch(`${API_URL}/career.php/get`);
      const data = await response.json();
      if (data.success) {
        setCareers(data.careers);
        setFilteredCareers(data.careers);
        
        // Extract unique departments
        const uniqueDepts = [...new Set(data.careers.map(career => career.department))];
        setDepartments(uniqueDepts);
      }
    } catch (error) {
      console.error('Error fetching careers:', error);
    } finally {
      setLoading(false);
    }
  };

  // Filter careers based on search and selected titles
  useEffect(() => {
    let filtered = careers;
    
    if (selectedTitles.length > 0) {
      filtered = filtered.filter(career => 
        selectedTitles.includes(career.title)
      );
    }
    
    if (searchTerm) {
      filtered = filtered.filter(career =>
        career.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        career.department.toLowerCase().includes(searchTerm.toLowerCase()) ||
        career.description.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    
    filtered = sortCareers(filtered, sortBy);
    setFilteredCareers(filtered);
  }, [careers, selectedTitles, searchTerm, sortBy]);

  const sortCareers = (careersList, sortType) => {
    const sorted = [...careersList];
    switch (sortType) {
      case 'newest':
        return sorted.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
      case 'oldest':
        return sorted.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
      case 'title_asc':
        return sorted.sort((a, b) => a.title.localeCompare(b.title));
      case 'title_desc':
        return sorted.sort((a, b) => b.title.localeCompare(a.title));
      default:
        return sorted;
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setShowDropdown(true);
  };

  const handleTitleSelect = (title) => {
    if (!selectedTitles.includes(title)) {
      setSelectedTitles([...selectedTitles, title]);
    }
    setSearchTerm('');
    setShowDropdown(false);
  };

  const removeTitle = (titleToRemove) => {
    setSelectedTitles(selectedTitles.filter(title => title !== titleToRemove));
  };

  const clearFilters = () => {
    setSelectedTitles([]);
    setSearchTerm('');
  };

  const handleCareerSelect = (career) => {
    setSelectedCareer(career);
    setShowOverlay(true);
    document.body.style.overflow = 'hidden';
  };

  const handleCloseSidebar = () => {
    setSelectedCareer(null);
    setShowOverlay(false);
    document.body.style.overflow = 'auto';
  };

  // Handle Apply Now button click
  const handleApplyNow = (career) => {
    setSelectedCareerForApplication(career);
    setShowApplicationModal(true);
    document.body.style.overflow = 'hidden';
  };

  const handleCloseApplicationModal = () => {
    setShowApplicationModal(false);
    setSelectedCareerForApplication(null);
    document.body.style.overflow = 'auto';
  };

  // Apply Now button particle functions
  const generateApplyParticles = (count, x, y) => {
    const newParticles = [];
    for (let i = 0; i < count; i++) {
      newParticles.push({
        id: Math.random(),
        x: x || Math.random() * 100,
        y: y || Math.random() * 100,
        size: Math.random() * 4 + 2,
        duration: Math.random() * 1 + 0.5,
        delay: Math.random() * 0.5
      });
    }
    return newParticles;
  };

  const handleApplyMouseEnter = (e) => {
    setIsApplyHovered(true);
    setApplyParticles(generateApplyParticles(8, 50, 50));
  };

  const handleApplyMouseLeave = () => {
    setIsApplyHovered(false);
    setTimeout(() => {
      setApplyParticles([]);
    }, 500);
  };

  useEffect(() => {
    if (isApplyHovered) {
      const particleInterval = setInterval(() => {
        setApplyParticles(prev => [...prev, ...generateApplyParticles(2)]);
      }, 200);
      
      return () => {
        clearInterval(particleInterval);
      };
    }
  }, [isApplyHovered]);

  const getTimeAgo = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffTime = Math.abs(now - date);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays === 1) return 'Today';
    if (diffDays === 2) return '1 day ago';
    if (diffDays <= 7) return `${diffDays - 1} days ago`;
    if (diffDays <= 30) return `${Math.floor(diffDays / 7)} weeks ago`;
    return `${Math.floor(diffDays / 30)} months ago`;
  };

  const formatSkills = (skills) => {
    if (!skills) return [];
    try {
      return typeof skills === 'string' ? JSON.parse(skills) : skills;
    } catch {
      return Array.isArray(skills) ? skills : [skills];
    }
  };

  const filteredTitles = careers
    .filter(career => 
      career.title.toLowerCase().includes(searchTerm.toLowerCase()) &&
      !selectedTitles.includes(career.title)
    )
    .map(career => career.title)
    .filter((title, index, self) => self.indexOf(title) === index)
    .slice(0, 5);

  return (
    <>
      <Topnavbar />
      <Navbar />
      
      {/* Overlay when sidebar is open */}
      {showOverlay && (
        <div 
          className="sidebar-overlay"
          onClick={handleCloseSidebar}
        />
      )}
      
      {/* Application Modal */}
      {showApplicationModal && (
        <CareersApplicatioms 
          career={selectedCareerForApplication}
          onClose={handleCloseApplicationModal}
        />
      )}

      {/* Hero Section */}
      <div
        style={{
          ...heroStyles.hero,
          backgroundImage: `url("/images/Productview.jpg")`,
        }}
      >
        <div style={heroStyles.heroOverlay}>
          <div style={heroStyles.container}>
            {/* Breadcrumbs */}
            <div style={heroStyles.breadcrumbs}>
              <a onClick={()=>navigate('/')} style={heroStyles.breadcrumbLink}>Home</a>
              <span style={heroStyles.breadcrumbSeparator}>/</span>
              <span className='text-white' style={{cursor:'pointer'}}>Careers</span>
            </div>

            {/* Hero Title */}
            <h1 style={heroStyles.heroTitle}>Join Our Team</h1>
            <p style={heroStyles.heroSubtitle}>
              Discover exciting career opportunities and grow with us
            </p>
          </div>
        </div>
      </div>
      
      <div className="careers-container">
        {/* Search and Filter Section */}
        <div className="search-filter-section">
          <div className="search-container">
            <div className="search-input-wrapper">
              <input
                type="text"
                placeholder="Search jobs by title, department..."
                value={searchTerm}
                onChange={handleSearchChange}
                onFocus={() => setShowDropdown(true)}
                className="search-input"
              />
              {showDropdown && searchTerm && filteredTitles.length > 0 && (
                <div className="search-dropdown">
                  {filteredTitles.map((title, index) => (
                    <div
                      key={index}
                      className="dropdown-item"
                      onClick={() => handleTitleSelect(title)}
                    >
                      {title}
                    </div>
                  ))}
                </div>
              )}
            </div>
            
            {/* Selected Titles */}
            <div className="selected-tags">
              {selectedTitles.map((title, index) => (
                <span key={index} className="selected-tag">
                  {title}
                  <button onClick={() => removeTitle(title)}>
                    <FontAwesomeIcon icon={faTimes} />
                  </button>
                </span>
              ))}
            </div>
          </div>
          
          <button 
            className="clear-filters-btn"
            onClick={clearFilters}
          >
            Clear Filters
          </button>
        </div>

        <div className="careers-header">
          <div className="header-top">
            <div className="jobs-text">
              <h1>Jobs for You</h1>
            </div>
            <div className="sort-container">
              <label>Sort by:</label>
              <select 
                value={sortBy} 
                onChange={(e) => setSortBy(e.target.value)}
                className="sort-select"
              >
                <option value="newest">Newest First</option>
                <option value="oldest">Oldest First</option>
                <option value="title_asc">Title A-Z</option>
                <option value="title_desc">Title Z-A</option>
              </select>
            </div>
          </div>
        </div>

        {/* Careers Grid */}
        <div className={`careers-content ${selectedCareer ? 'with-sidebar' : ''}`}>
          <div className="careers-grid">
            {loading ? (
              <div className="loading">Loading careers...</div>
            ) : filteredCareers.length > 0 ? (
              filteredCareers.map(career => (
                <div 
                  key={career.id} 
                  className="career-card"
                  onClick={() => handleCareerSelect(career)}
                >
                  <div className="card-image">
                    {career.featured_image_url ? (
                      <img 
                        src={`${API_URL}/${career.featured_image_url}`} 
                        alt={career.title}
                        onError={(e) => {
                          e.target.style.display = 'none';
                          e.target.nextSibling.style.display = 'flex';
                        }}
                      />
                    ) : null}
                    <div className="image-placeholder">
                      {career.department?.charAt(0) || 'J'}
                    </div>
                  </div>
                  
                  <div className="card-content">
                    <div className="card-header">
                      <h3 className="job-title">{career.title}</h3>
                      <span className="department">{career.department}</span>
                    </div>
                    
                    <div className="card-meta">
                      <span className="time-ago">
                        <FontAwesomeIcon icon={faClock} />
                        {getTimeAgo(career.created_at)}
                      </span>
                      <span className="job-type">
                        <FontAwesomeIcon icon={faBriefcase} />
                        {career.job_type}
                      </span>
                      {/* <span className="deadline">
                        <FontAwesomeIcon icon={faCalendarAlt} />
                        Apply by: {new Date(career.application_deadline).toLocaleDateString()}
                      </span> */}
                    </div>
                    
                    <div className="card-skills">
                      <div className="skills-department">
                        <strong>Skills</strong>
                        {formatSkills(career.skills).slice(0, 3).join(', ')}
                        {formatSkills(career.skills).length > 3 && '...'}
                      </div>
                      <div className="skills-department">
                        <strong>Department</strong>
                        {career.department}
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="no-results">
                No careers found matching your criteria.
              </div>
            )}
          </div>

          {/* Sidebar for Career Details */}
          {selectedCareer && (
            <div className="career-sidebar">
              <div className="sidebar-header">
                <h2>Job Details</h2>
                <button 
                  className="close-sidebar"
                  onClick={handleCloseSidebar}
                >
                  <FontAwesomeIcon icon={faTimes} />
                </button>
              </div>
              
              <div className="sidebar-content">
                <div className="detail-section">
                  <h3>{selectedCareer.title}</h3>
                  <div className="detail-meta">
                    <div className="detail-meta-item">
                      <span className="detail-meta-label">Department:</span>
                      <span className="detail-meta-value">{selectedCareer.department}</span>
                    </div>
                    <div className="detail-meta-item">
                      <span className="detail-meta-label">Location:</span>
                      <span className="detail-meta-value">{selectedCareer.location}</span>
                    </div>
                    <div className="detail-meta-item">
                      <span className="detail-meta-label">Job Type:</span>
                      <span className="detail-meta-value">{selectedCareer.job_type}</span>
                    </div>
                    <div className="detail-meta-item">
                      <span className="detail-meta-label">Experience:</span>
                      <span className="detail-meta-value">{selectedCareer.experience_level}</span>
                    </div>
                    <div className="detail-meta-item">
                      <span className="detail-meta-label">Posted:</span>
                      <span className="detail-meta-value">{getTimeAgo(selectedCareer.created_at)}</span>
                    </div>
                    {/* <div className="detail-meta-item">
                      <span className="detail-meta-label">Application Deadline:</span>
                      <span className="detail-meta-value">
                        {new Date(selectedCareer.application_deadline).toLocaleDateString()}
                      </span>
                    </div> */}
                  </div>
                </div>

                <div className="detail-section">
                  <h4>Job Description</h4>
                  <p>{selectedCareer.description}</p>
                </div>

                {selectedCareer.requirements && (
                  <div className="detail-section">
                    <h4>Requirements</h4>
                    <p>{selectedCareer.requirements}</p>
                  </div>
                )}

                {selectedCareer.responsibilities && (
                  <div className="detail-section">
                    <h4>Responsibilities</h4>
                    <p>{selectedCareer.responsibilities}</p>
                  </div>
                )}

                <div className="detail-section">
                  <h4>Skills Required</h4>
                  <div className="skills-list">
                    {formatSkills(selectedCareer.skills).map((skill, index) => (
                      <span key={index} className="skill-tag">{skill}</span>
                    ))}
                  </div>
                </div>

                <div className="detail-section">
                  <h4>Salary & Benefits</h4>
                  <p><strong>Salary Range:</strong> {selectedCareer.salary_range || 'Competitive salary'}</p>
                  <p><strong>Experience Required:</strong> {selectedCareer.min_experience || '0'} - {selectedCareer.max_experience || 'Not specified'} years</p>
                  {selectedCareer.benefits && (
                    <p><strong>Benefits:</strong> {selectedCareer.benefits}</p>
                  )}
                </div>
              </div>
              
              {/* Updated Footer with Two Buttons */}
              <div className="sidebar-footer">
                <button 
                  className="cancel-btn"
                  onClick={handleCloseSidebar}
                >
                  <span className="cancel-btn__text">Cancel</span>
                </button>
                
                <button 
                  ref={applyButtonRef}
                  className={`apply-now-btn ${isApplyHovered ? 'apply-now-btn--hovered' : ''}`}
                  onMouseEnter={handleApplyMouseEnter}
                  onMouseLeave={handleApplyMouseLeave}
                  onClick={() => handleApplyNow(selectedCareer)}
                >
                  <span className="apply-now-btn__text">Apply Now ↗</span>
                  
                  {/* Animated border elements */}
                  <span className="apply-now-btn__border apply-now-btn__border--top"></span>
                  <span className="apply-now-btn__border apply-now-btn__border--right"></span>
                  <span className="apply-now-btn__border apply-now-btn__border--bottom"></span>
                  <span className="apply-now-btn__border apply-now-btn__border--left"></span>
                  
                  {/* Floating particles */}
                  <div className="apply-now-btn__particles">
                    {applyParticles.map(particle => (
                      <span
                        key={particle.id}
                        className="apply-now-btn__particle"
                        style={{
                          left: `${particle.x}%`,
                          top: `${particle.y}%`,
                          width: `${particle.size}px`,
                          height: `${particle.size}px`,
                          animationDuration: `${particle.duration}s`,
                          animationDelay: `${particle.delay}s`
                        }}
                      />
                    ))}
                  </div>
                  
                  {/* Glow effect */}
                  <span className="apply-now-btn__glow"></span>
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  )
}